import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
const TARGET_DATE = new Date('2026-04-30T00:00:00-04:00').getTime();
const useCountdown = () => {
  const [timeLeft, setTimeLeft] = useState(() => {
    const diff = TARGET_DATE - Date.now();
    return diff > 0 ? diff : 0;
  });
  useEffect(() => {
    const timer = setInterval(() => {
      const diff = TARGET_DATE - Date.now();
      setTimeLeft(diff > 0 ? diff : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
  const hours = Math.floor(timeLeft % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
  const minutes = Math.floor(timeLeft % (1000 * 60 * 60) / (1000 * 60));
  const seconds = Math.floor(timeLeft % (1000 * 60) / 1000);
  return {
    days,
    hours,
    minutes,
    seconds
  };
};
const CountdownUnit = ({
  value,
  label
}: {
  value: number;
  label: string;
}) => <div className="flex flex-col items-center" data-id="element-156">
    <span className="text-xl sm:text-2xl font-bold font-serif tabular-nums leading-none" data-id="element-157">
      {String(value).padStart(2, '0')}
    </span>
    <span className="text-[9px] uppercase tracking-widest text-[#F7F5EE] mt-1.5" data-id="element-158">
      {label}
    </span>
  </div>;
export const HeroSection = () => {
  const {
    days,
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section className="relative bg-gradient-to-r from-[#5A5535] to-[#3D3A25] text-white overflow-hidden" data-id="element-159">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1557683316-973673baf926?q=80&w=2070')] opacity-10 bg-no-repeat bg-cover mix-blend-overlay" data-id="element-160"></div>
      <div className="absolute inset-0 bg-grid-white/[0.05] bg-[size:20px_20px]" data-id="element-161"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32 relative z-10" data-id="element-162">
        <div className="md:w-3/4 lg:w-2/3" data-id="element-163">
          <div className="flex flex-wrap items-center gap-4 mb-6" data-id="element-164">
            <div className="bg-[#C4A44A] text-[#1E1D14] px-4 py-1.5 rounded-sm text-xs font-bold uppercase tracking-wider" data-id="element-165">
              Next Round Opening April 30, 2026
            </div>
            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm border border-[#D4C88A]/30 px-4 py-2 rounded-sm" data-id="element-166">
              <CountdownUnit value={days} label="Days" data-id="element-167" />
              <span className="text-[#C4A44A] text-lg font-light -mt-3" data-id="element-168">:</span>
              <CountdownUnit value={hours} label="Hrs" data-id="element-169" />
              <span className="text-[#C4A44A] text-lg font-light -mt-3" data-id="element-170">:</span>
              <CountdownUnit value={minutes} label="Min" data-id="element-171" />
              <span className="text-[#C4A44A] text-lg font-light -mt-3" data-id="element-172">:</span>
              <CountdownUnit value={seconds} label="Sec" data-id="element-173" />
            </div>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 font-serif leading-tight" data-id="element-174">
            The Future of <br data-id="element-175" />
            Domain Names
          </h1>
          <p className="text-xl md:text-2xl mb-10 text-[#EDE9DB] font-light max-w-2xl leading-relaxed" data-id="element-176">
            Prepare now for the 2026 application round for new generic Top-Level
            Domains (gTLDs).
          </p>
          <div className="flex flex-col sm:flex-row gap-5" data-id="element-177">
            <a href="#process" className="bg-white text-[#5A5535] px-8 py-4 rounded-sm font-bold uppercase tracking-wider inline-flex items-center hover:bg-[#F7F5EE] transition-colors shadow-lg" data-id="element-178">
              Start Preparing
              <ArrowRightIcon className="ml-2 h-5 w-5 text-[#C4A44A]" data-id="element-179" />
            </a>
            <a href="#about" className="border border-[#D4C88A] text-[#EDE9DB] px-8 py-4 rounded-sm font-bold uppercase tracking-wider hover:bg-[#C4A44A]/10 hover:border-[#C4A44A] hover:text-white transition-colors" data-id="element-180">
              Learn More
            </a>
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-[#FAF9F5] to-transparent" data-id="element-181"></div>
    </section>;
};